<template>
  <div class="manualStartStop">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <el-form label-position="right" :model="searchForm" class="form" label-width="80px">
        <el-form-item :label="$t('panelNumber')">
          <el-input-number size="mini" v-model="searchForm.controllerNo" :min="0" :max="254"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('loopNo')">
          <el-input-number size="mini" v-model="searchForm.loopNo" :min="0" :max="254"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('addressNumber')">
          <el-input-number size="mini" v-model="searchForm.codeNo" :min="0" :max="254"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 90px" type="primary" :loading="loading1" @click="_setDeviceShield(1)">{{$t('startUp')}}</el-button>
          <el-button style="width: 90px" type="primary" :loading="loading2" @click="_setDeviceShield(0)">{{$t('stop')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import {setManualStartStop} from "@/api/setting";
import Status from "components/Status";
export default {
  name: "manualStartStop",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      searchForm: {
        codeNo: '',
        loopNo: '',
        controllerNo: ''
      },
      bottomHeight: null,
      style: null,
      loading1: false,
      loading2: false
    }
  },
  mounted() {
    this.calcHeight()
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
   created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  methods: {
    calcHeight(){
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    _setDeviceShield(type){
      if (type === 1) {
        this.loading1 = true
        this.show()
      } else {
        this.loading2 = true
        this.show()
      }
      if (this.searchForm.codeNo === '') {
        this.$message.warning('请指定部位号!')
        return
      }
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.searchForm.controllerNo,
        loopNo: this.searchForm.loopNo,
        codeNo: this.searchForm.codeNo,
        type: type
      }
      setManualStartStop(searchParams).then((res) => {
        if (res.code === 1) {
          if (type === 1) {
            this.loading1 = false
            this.success(res.message ? res.message : '操作成功')
          } else {
            this.loading2 = false
            this.success(res.message ? res.message : '操作成功')
          }
        }
      }).catch(() => {
        if (type === 1) {
          this.loading1 = false
          this.failed()
        } else {
          this.loading2 = false
          this.failed()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.manualStartStop{
  .form{
    text-align: center;
    .el-form-item{
      width: 270px;
      text-align: center;
      margin: auto;
      padding: 5px;
      &:nth-child(3){
        padding-bottom: 10px;
      }
      .el-form-item__content{
        width: 130px;
      }
      .el-input-number--mini{
        width: 190px;
      }
    }
    .el-input-number.is-without-controls .el-input__inner {
      width: 100px;
      line-height: 30px;
      height: 28px;
    }

  }
}
</style>
